import "core-js/modules/es6.function.name";
import React from 'react';
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import hoistNonReactStatics from 'hoist-non-react-statics';
import GestureHandlerRootView from "./GestureHandlerRootView";
export default function gestureHandlerRootHOC(Component) {
  var containerStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  function Wrapper(props) {
    return React.createElement(GestureHandlerRootView, {
      style: [styles.container, containerStyles]
    }, React.createElement(Component, props));
  }

  Wrapper.displayName = "gestureHandlerRootHOC(" + (Component.displayName || Component.name) + ")";
  hoistNonReactStatics(Wrapper, Component);
  return Wrapper;
}
var styles = StyleSheet.create({
  container: {
    flex: 1
  }
});